// Generated by /client/scripts/generate-icon-components.mjs
// DO NOT EDIT DIRECTLY

import type React from "react";

import checkCircleIcon from "@/assets/icons/check-circle.svg";

import { Icon, type IconProps } from "../Icon/Icon";

type CheckCircleIconProps = Omit<IconProps, "name">;

export function CheckCircleIcon(props: CheckCircleIconProps): React.ReactNode {
  return <Icon name={checkCircleIcon} {...props} />;
}
